export class User {

	constructor(
		public id: number = null,
		public role: string = '',
		public name: string = '',
		public surname: string = '',
		public email: string = '',
		public password: string = '',
		public company: string = '',
		public birthDate: any = '',
		public recommended_by: string = '',
		public gender: string = '',
		public estadoCivil: string = '',
		public ocupation: string = '',
		public bornCity: string = '',
		public nationality: string = '',
		public address: string = '',
		public address2: string = '',
		public colonia: string = '',
		public city: string = '',
		public zipCode: string = '',
		public country: string = '',
		public phone: string = '',
		public mobilePhone: string = '',
		public contactoNombreEmergencia: string = '',
		public contactoTelefonoEmergencia: string = '',
		public motivoConsulta: string = '',
		public grupoSanguineo: string = '',
		public principioEvolucionPadecimiento: string = '',
		public antecedentesPsiquiatricos: string = '',
		public blacklist: string = '',
		public comisionVentas: number = null,
		public created_at: string = '',
		public firstLogin: number = null,
		public activo: number = null,
		public managedBy: number = null,
		public emailFrequency: string = '',
		public sendEmail: number = null,
		public companyLinked: any = null,
		public enableAsDriver: any = null,
		public customerType: string = '',
		public customerPricing: number = 0,
		public customerResponseTime: number = 0,
		public customerPaymentOnTime: number = 0,
		public customerEasyToWorkWith: number = 0,
		public holidayHours: any = null,
		public horasPagadasUsadas: any = null,
		public horasNoPagadasUsadas: any = null,
		public location: any = {id: null},
		public condition: any = {id: null},
		public term: any = null,
		public currency: any = null,
		public joinToWork: any = null,
		public locationId: number = null,
		public idcompany: number = null,
		public user_id: number = null,
		public typeLocationSelected: string = 'Headquarter',
		public deptoToCount: string = '',
		public iqInitials: string = '',
		public labelBarcode: any = 0,
		public barcodeType: string = '',
		public bugTicketNotify:number = 0,
		public managedByString:string = '',
	){}
}